import { InvoiceStatusEnum } from 'domains-billing-types';

export function isInvoiceBilled(
  status: string,
  isBilledStatusEnabled: boolean
): boolean {
  return isBilledStatusEnabled && status === InvoiceStatusEnum.BILLED;
}

export function isManagedInvoiceStatus(
  status: string,
  isBilledStatusEnabled: boolean
): boolean {
  return (
    status === InvoiceStatusEnum.EXTERNALLY_MANAGED ||
    isInvoiceBilled(status, isBilledStatusEnabled)
  );
}

export function getInvoiceDueDateLabelKey(
  status: string,
  isBilledStatusEnabled: boolean
): string | null {
  if (isInvoiceBilled(status, isBilledStatusEnabled)) {
    return 'abp.invoiceList.status.billed';
  }

  if (status === InvoiceStatusEnum.EXTERNALLY_MANAGED) {
    return 'abp.invoiceList.status.managedExternally';
  }

  return null;
}
